import { Component, OnInit } from '@angular/core';
import { SaveService } from '../shared/services/save.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private saveService: SaveService) { }

  ngOnInit() {
    this.saveService.setTitle("Accueil");
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/home/home.component.ts